export default "__VITE_ASSET__BL803fBq__"